/** Client-safe URL builders for hub links (no fs - safe in components). */

export const HUB_BASE = 'knowledge';

const prefix = (lang?: string): string => (lang && lang !== 'en' ? `/${lang}` : '');

export const hubPath = (lang?: string): string => `${prefix(lang)}/${HUB_BASE}`;

export const topicPath = (slug: string, lang?: string): string => `${prefix(lang)}/${HUB_BASE}/${slug}`;

export const groupPath = (group: string, lang?: string): string => `${prefix(lang)}/${HUB_BASE}/${group}`;

export const familyPath = (group: string, family: string, lang?: string): string =>
  `${prefix(lang)}/${HUB_BASE}/${group}/${family}`;
